import * as Yup from 'yup';

export const CreateOrUpdateDistrictSchema = Yup.object().shape({
  name: Yup.string().trim().required(),
});
